
import Marquee from "react-fast-marquee";
import { Text } from "@chakra-ui/react";

interface ParallaxTextProps {
	text: string;
	direction: "left" | "right" | "up" | "down";
	speed: number;
}

/**
 * The Parallax Text Component
 * @returns The Parallax Text Component
 */
export default function ParallaxTextComponent(props: ParallaxTextProps) {

    return (
        <Marquee
            speed={props.speed}
            autoFill={true}
            style={{
                fontFamily: "Source Code Pro Variable",
                fontWeight: "600",
                fontSize: "64px",
                textTransform: "uppercase",
            }}
            direction={props.direction}
        >
            <Text
                _hover={{
                    color: "blue.300",
                }}
                transition={"color 0.3s"}
            >{props.text}&nbsp;</Text>
        </Marquee>
    );
}
